import React from 'react';

import * as S from './styles';

import { CardsHomeSpecial } from '../../micros/CardsHomeSpecial';
import { BannerSpecial } from '../../micros/BannerSpecial';

import { CardsHomeSpecialProps } from '../../micros/CardsHomeSpecial/types';
import { BannerSpecialProps } from '../../micros/BannerSpecial/types';

const SectionCardsHomeSpecial = (
	props: CardsHomeSpecialProps & BannerSpecialProps
) => {
	return (
		<S.Section>
			<BannerSpecial banners={props.banners} />
			<S.SectionWrapper>
				<CardsHomeSpecial {...props} />
			</S.SectionWrapper>
		</S.Section>
	);
};

export default SectionCardsHomeSpecial;
